import { NavigationItem } from '../navigation_item';

export interface NavigationState {
  navigationItems: Array<NavigationItem>;
}

export const initialNavigationState: NavigationState = {
  navigationItems: []
};


